import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy `/account/add-provider` route — superseded by the modal flow at
 * `_authenticated` layout (`?add=provider&aStep=N`). Redirect on load so
 * existing deep-links + bookmarks still land in the wizard at step 1 (Type).
 */
export const Route = createFileRoute("/_authenticated/account/add-provider")({
  validateSearch: (search: Record<string, unknown>): { step?: number } => ({
    step:
      typeof search.step === "number"
        ? search.step
        : typeof search.step === "string"
          ? Number.parseInt(search.step, 10) || undefined
          : undefined,
  }),
  beforeLoad: ({ search }) => {
    const aStep = search.step;
    throw redirect({
      to: "/account/user/dashboard",
      search: aStep ? { add: "provider", aStep } : { add: "provider" },
    });
  },
});
